import { useRef } from 'react';
var empty = Symbol('empty');
export function useCallbackRef(cb) {
  var ref = useRef(empty);

  if (ref.current === empty) {
    ref.current = cb();
  }

  return ref;
}